import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import classnames from 'classnames';

import { formatDate } from '../../../../utils/date-utils';
import Calendar from '../calendar/Calendar';
import withSingleSelection from '../calendar/withSingleSelection';
import Input from 'material-ui/Input';

const CalendarWithSingleSelection = withSingleSelection(Calendar);
const StyledWrap = styled.div`
  position: relative;
  input {
    margin-top: 1rem;
  }
`;
const CalendarWrap = styled.div`
  display: none;
  &.visible {
    display: block;
  }
`;

class DatePickerInput extends Component {
  state = {
    selectedDate: moment().startOf('day'),
    calendarVisible: false,
  };

  componentWillReceiveProps = (nextProps) => {
    if(!nextProps.value) {
      this.setState({
        selectedDate: moment()
      }, this.onDateSelected(this.state.selectedDate));
    }
  };

  componentDidMount = () => {
    this.props.onChange({
      target: this.dateInput.name,
      value: this.state.selectedDate,
    });
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.hideCalendar);
  };

  onDateFocus = (event) => {
    if(this.state.calendarVisible) return;
    this.showCalendar();
  };

  onDateSelected = (date) => {
    this.setState({
      selectedDate: date,
      calendarVisible: false,
    });
    this.props.onChange({
      target: {
        name: this.dateInput.name,
        value: date,
      }
    });
    document.removeEventListener('click', this.hideCalendar);
  };

  hideCalendar = (event) => {
    if(!this.state.calendarVisible) return;
    document.removeEventListener('click', this.hideCalendar);
    this.setState({
      calendarVisible: false
    });
  };

  showCalendar = (event) => {
    if(this.state.calendarVisible) return;
    this.setState({
      calendarVisible: true
    });
    setTimeout(() => {
      document.addEventListener('click', this.hideCalendar);
    }, 150);
  };

  onWrapClick = (event) => {
    if(!this.state.calendarVisible) return;
    event.stopPropagation();
    event.nativeEvent.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  render() {
    const {
      onChange,
      name,
      firstPossibleDate,
      lastPossibleDate,
			inputProps,
      ...rest
    } = this.props;

    const calendarClass = classnames({
      visible: this.state.calendarVisible
    });
    
    return (
      <StyledWrap>
        <Input
          readOnly
					inputProps={inputProps}
          {...rest}
          name={name}
          value={formatDate(this.state.selectedDate)}
          innerRef={(input) => { this.dateInput = input; }}
          onFocus={this.onDateFocus}
          onChange={onChange}
          onClick={this.showCalendar}
        />
        <CalendarWrap className={calendarClass} onClick={this.onWrapClick}>
          <CalendarWithSingleSelection
            firstPossibleDate={firstPossibleDate}
            lastPossibleDate={lastPossibleDate}
            selectedDate={this.state.selectedDate}
            onDateSelected={this.onDateSelected}
          />
        </CalendarWrap>
      </StyledWrap>
    );
  }
}

DatePickerInput.defaultProps = {
  firstPossibleDate : moment(new Date(2017, 0, 1)).hours(0).minutes(0).seconds(0),
  lastPossibleDate : moment(new Date(2099, 0, 1)).hours(0).minutes(0).seconds(0),
};

export default DatePickerInput;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/DatePickerInput.js